import { default as fastifySupabase } from "./fastify-supabase";

export default fastifySupabase;
